import React from 'react';

// Styles & Assets
import styles from './RouteReadyDialog.module.css';
import { MdOutlineContentCopy, MdOutlineLocationOn } from 'react-icons/md';

// Hooks
import { useToast } from '../../../hooks/useToast';

// Interface
import { Location } from '../../../interfaces/Location';

// Language
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const RouteReadyDialog: React.FC<{
    setModalOpened: React.Dispatch<React.SetStateAction<boolean>>,
    addresses: Location[]
}> = ({ setModalOpened, addresses }) => {

    const { t } = useTranslation();
    const { success } = useToast();

    const navigate = useNavigate();

    const getLocations = () => addresses.map(a => a.lat + ',' + a.lng).join('/');

    const link = 'https://www.google.com/maps/dir/' + getLocations();

    const handleClickCopyLink = () => {
        navigator.clipboard.writeText(link);
        success(t('copy_clipboard'));
    };

    const handleClickOpenMaps = () => {
        window.open(link, '_blank');
    };

    const handleClickAccept = () => {
        setModalOpened(false);
        navigate('/home/routes/routes_map_patients');
    };

    return (
        <div className='dialog'>
            <div className={styles.contentContainer}>
                <h1>{t('route_ready')}</h1>
                <h3>{t('here_link')}:</h3>
                <p className={styles.link}>{link}</p>
                <div className={styles.buttonsContainer}>
                    <button onClick={handleClickCopyLink}>
                        <MdOutlineContentCopy />
                        <span>{t('copy_link')}</span>
                    </button>
                    <button onClick={handleClickOpenMaps}>
                        <MdOutlineLocationOn />
                        <span>{t('open_maps')}</span>
                    </button>
                </div>
                <button onClick={handleClickAccept} className={styles.acceptButton}>
                    {t('accept')}
                </button>
            </div>
        </div>
    );
};

export default RouteReadyDialog;